import { gsap, TimelineMax } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const initCarAnimation = () => {
    const carLeaveScene = new TimelineMax({ paused: true });
    carLeaveScene.from('.buying-online-hero--car-image', { x: '350px', duration: 0 });
    carLeaveScene.to('.buying-online-hero--car-image', {
        x: `-${window.innerWidth * 2}px`,
        ease: 'Power3.in',
        duration: 4,
    });

    ScrollTrigger.create({
        trigger: '.buying-online-hero--car-image',
        start: 'top top',
        animation: carLeaveScene,
        invalidateOnRefresh: true,
    });

    gsap.to('.buying-online-hero--car-image', { x: 0, duration: 2, ease: 'Power3.out', delay: 0.25 });
};

export const step1Transition = () => {
    const deliveryTextTransition = new TimelineMax();
    const epuTextTransition = new TimelineMax();

    deliveryTextTransition.fromTo('.step-1-delivery-text', { y: 120 }, { y: 0, ease: 'back.out(.75)', duration: 0.75 });
    deliveryTextTransition.from('.step-1-delivery-text', { opacity: 0, duration: 0.75 }, '-=.75');
    epuTextTransition.fromTo('.step-1-epu-text', { y: 120 }, { y: 0, ease: 'back.out(.75)', duration: 0.75 });
    epuTextTransition.from('.step-1-epu-text', { opacity: 0, duration: 0.75 }, '-=.75');

    ScrollTrigger.create({
        trigger: '.step-1-square-img-container-delivery',
        start: 'top center',
        animation: deliveryTextTransition,
        toggleActions: 'play reverse play reverse',
    });
    ScrollTrigger.create({
        trigger: '.step-1-square-img-container-epu',
        start: 'top center',
        animation: epuTextTransition,
        toggleActions: 'play reverse play reverse',
    });
};

export const step2Transition = () => {
    const textCommunication = new TimelineMax();
    textCommunication.fromTo(
        '.buying-online-steps--communication-bubble-1',
        { y: 80 },
        { y: 0, ease: 'back.out(.75)', duration: 0.75 },
    );
    textCommunication.from('.buying-online-steps--communication-bubble-1', { opacity: 0, duration: 0.75 }, '-=.75');
    textCommunication.fromTo(
        '.buying-online-steps--communication-bubble-2',
        { y: 80 },
        { y: 0, ease: 'back.out(.75)', duration: 0.75 },
    );
    textCommunication.from('.buying-online-steps--communication-bubble-2', { opacity: 0, duration: 0.75 }, '-=.75');

    ScrollTrigger.create({
        trigger: '.buying-online-steps--step-2',
        start: 'top+=140 center',
        animation: textCommunication,
        toggleActions: 'play reverse play reverse',
    });
};

export const step3Transition = () => {
    const signatureModal = new TimelineMax();
    signatureModal.from('.buying-online-steps--signature-container', {
        scale: 0.5,
        opacity: 0,
        ease: 'back.out(2.25)',
        duration: 0.625,
    });
    signatureModal.from(
        '.buying-online-steps--signature-underline',
        { width: 0, ease: 'Power3.easeOut', duration: 0.5 },
        '-=.125',
    );
    signatureModal.from(
        '.buying-online-steps--signature-sign-flag',
        { opacity: 0, y: -45, ease: 'back.out(1.7)', duration: 0.5 },
        '-=.3625',
    );
    signatureModal.from('#buying-online-steps--signature-svg path', { drawSVG: false, duration: 1.5 });

    ScrollTrigger.create({
        trigger: '.buying-online-steps--step-3',
        start: 'top center',
        animation: signatureModal,
        toggleActions: 'play reverse play reverse',
    });
};
